import {createUseStyles} from "react-jss";
import {breakpoints} from "constants/breakpoints";
import {colors} from "constants/colors";
import leftArrow from "resources/images/carousel-left-arrow.svg";
import rightArrow from "resources/images/carousel-right-arrow.svg";

const styles = createUseStyles({
  carouselStyle: {
    paddingLeft: 0,
    paddingRight: 0,
    height: "auto",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "auto 32px",
    "& .carousel-inner": {
      gridColumnStart: 1,
      gridColumnEnd: 4,
      display: "flex",

      "& .carousel-item-next, & .carousel-item-prev": {
        display: "flex",
      },
      "& .carousel-item": {

        "&.active": {
          display: "flex",
          columnGap: "10px"
        },
        justifyContent: "space-between",
        alignItems: "flex-start",

        '& .carousel-tab-mobile': {
          flex: "0 0 100%",
          maxWidth: "100%",
        }
      }
    },
    "& .carousel-indicators": {
      display: "flex",
      gridColumnStart: 2,
      gridColumnEnd: 3,
      gridRowStart: 2,
      gridRowEnd: 3,
      margin: "8px 64px",
      [`@media (max-width: ${breakpoints.lg}px)`]: {
        margin: "8px 32px",
      },
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        margin: "8px",
      },
      "& button": {
        opacity: 1,
        backgroundColor: colors.shadowGrey,
        borderRadius: "3px",
        height: "6px",
        border: "unset"
      },
      "& .active": {
        backgroundColor: colors.primary700Blue
      }
    },
    '& .carousel-control-next': {
      top: "unset",
      bottom: "-8px",
      display: "grid",
      width: "100%",
      height: "36px",
      gridColumnStart: 3,
      gridColumnEnd: 4,
      justifyContent: "start"
    },
    '& .carousel-control-prev': {
      top: "unset",
      bottom: "-8px",
      display: "grid",
      width: "100%",
      height: "36px",
      gridColumnStart: 1,
      gridColumnEnd: 2,
      justifyContent: "end"
    },
    '& .carousel-control-prev-icon': {
      backgroundImage: `url(${leftArrow})`,
      height: "20px"
    },

    '& .carousel-control-next-icon': {
      backgroundImage: `url(${rightArrow})`,
      height: "20px"
    }
  }
});

export default styles;
